module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-full"
  }, [_c('div', {
    staticClass: "acompanhamento-lance h-full",
    class: {
      'isLoading': _vm.isLoading, isOnline: _vm.apelido !== 'PLATEIA' && _vm.apelido !== '-'
    }
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "lote-numero col0"
  }, [_vm._v("Lote " + _vm._s(_vm.lote.numero))]), _vm._v(" "), _c('div', {
    staticClass: "tipoLance col0"
  }, [(_vm.apelido !== 'PLATEIA') ? _c('span', [_vm._v("Online")]) : _c('span', [_vm._v("PLATEIA")])])]), _vm._v(" "), _c('div', {
    staticClass: "lance"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "lbl"
  }, [_vm._v("Lance Atual")]), _vm._v(" "), _c('div', {
    staticClass: "box valorAtual",
    class: {
      novoLance: _vm.hasNovoLance
    }
  }, [_vm._v(_vm._s(_vm._f("moeda")(_vm.valor)))])]), _vm._v(" "), _c('div', {
    staticClass: "col arrematante"
  }, [_c('div', {
    staticClass: "lbl"
  }, [_vm._v("Arrematante")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [(_vm.apelido !== 'PLATEIA' && _vm.apelido !== '-') ? _c('p', {
    staticClass: "apelido"
  }, [_vm._v(_vm._s(_vm.apelido))]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "localidade"
  }, [_vm._v(_vm._s(_vm.lanceLocalidade))]), _vm._v(" "), _c('p', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm.lanceData))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d7e69ec","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/pregao-lance/Main.vue
// module id = 760
// module chunks = 2